import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  SearchUsers200,
  SearchUsers400,
  SearchUsers401,
  SearchUsers500,
  SearchUsersParams
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * @summary 사용자 검색
 */
export const searchUsers = (
    params: SearchUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchUsers200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/users/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSearchUsersQueryKey = (params: SearchUsersParams,) => {
    return [`https://api.ugot.uk/api/users/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchUsersInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof searchUsers>>, TError = AxiosError<SearchUsers400 | SearchUsers401 | SearchUsers500>>(params: SearchUsersParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsers>>> = ({ signal }) => searchUsers(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchUsersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>
export type SearchUsersInfiniteQueryError = AxiosError<SearchUsers400 | SearchUsers401 | SearchUsers500>

/**
 * @summary 사용자 검색
 */
export const useSearchUsersInfinite = <TData = Awaited<ReturnType<typeof searchUsers>>, TError = AxiosError<SearchUsers400 | SearchUsers401 | SearchUsers500>>(
 params: SearchUsersParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchUsersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSearchUsersQueryOptions = <TData = Awaited<ReturnType<typeof searchUsers>>, TError = AxiosError<SearchUsers400 | SearchUsers401 | SearchUsers500>>(params: SearchUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsers>>> = ({ signal }) => searchUsers(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>
export type SearchUsersQueryError = AxiosError<SearchUsers400 | SearchUsers401 | SearchUsers500>

/**
 * @summary 사용자 검색
 */
export const useSearchUsers = <TData = Awaited<ReturnType<typeof searchUsers>>, TError = AxiosError<SearchUsers400 | SearchUsers401 | SearchUsers500>>(
 params: SearchUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



